import { StateCreator } from "zustand";
// The messages module directly: the @/lib/ably/vision barrel pulls hooks that import this store.
import { PEER_SCREEN_BASE_COLOR } from "../../lib/ably/vision/messaging/messages";
import { Storage } from "../index";

export type PeerPhase =
	| "pairing"
	| "grading"
	| "waiting-for-results"
	| "offer-status"
	| "continue-on-scanner"
	| "redirection"
	| "self-functional-assessments";

export type PeerOfferStatus = "idle" | "offer-presented" | "report-presented";

export interface PeerSessionState {
	phase: PeerPhase;
	backgroundColor: string;
	takingPhoto: boolean;
	offerStatus: PeerOfferStatus;
}

export interface PeerSessionSlice {
	peerSession: PeerSessionState;
	setPeerPhase: (phase: PeerPhase) => void;
	setBackgroundColor: (backgroundColor: string) => void;
	setTakingPhoto: (takingPhoto: boolean) => void;
	setPeerOfferStatus: (offerStatus: PeerOfferStatus) => void;
	resetPeerSession: () => void;
}

const initialPeerSessionState: PeerSessionState = {
	phase: "pairing",
	backgroundColor: PEER_SCREEN_BASE_COLOR,
	takingPhoto: false,
	offerStatus: "idle",
};

export const createPeerSessionSlice: StateCreator<Storage, [], [], PeerSessionSlice> = (set) => ({
	peerSession: initialPeerSessionState,
	setPeerPhase: (phase) =>
		set((state) => ({
			peerSession: {
				...state.peerSession,
				phase,
			},
		})),
	setBackgroundColor: (backgroundColor) =>
		set((state) => ({
			peerSession: {
				...state.peerSession,
				backgroundColor,
			},
		})),
	setTakingPhoto: (takingPhoto) =>
		set((state) => ({
			peerSession: {
				...state.peerSession,
				takingPhoto,
			},
		})),
	setPeerOfferStatus: (offerStatus) =>
		set((state) => ({
			peerSession: {
				...state.peerSession,
				offerStatus,
			},
		})),
	resetPeerSession: () =>
		set(() => ({
			peerSession: initialPeerSessionState,
		})),
});
